<div class="file-drop-area" [ngClass]="{ fileOver: fileOver }">
    <span (click)="fileInput.click()" class="btn btn-primary">{{
        'DOCBOX_UPLOAD_FORM_FILE_SELECT_HINT' | translate
    }}</span>
    <span class="file-msg ms-3">{{
        file ? file.name : ('DOCBOX_UPLOAD_FORM_FILE_SELECT_FILENAME_ALT' | translate)
    }}</span>
    <img
        *ngIf="thumbnail !== undefined"
        class="thumbnail"
        [alt]="'DOCBOX_UPLOAD_FORM_FILE_SELECT_THUMBNAIL_ALT' | translate"
        [src]="thumbnail"
    />
    <br />
    <span *ngIf="thumbnail === undefined">{{ 'DOCBOX_UPLOAD_FORM_FILE_SELECT_NO_PREVIEW' | translate }}</span>
    <input
        [accept]="allowedMimeTypes.join(',')"
        hidden="true"
        type="file"
        #fileInput
        [attr.aria-label]="'DOCBOX_UPLOAD_FORM_FILE_SELECT' | translate"
    />
</div>
